<script>
    import Library from '../../Models/LibraryORM';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {confirm} from '../Confirmation.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {tables} from '../../lib/tables';

    import { isAdmin } from '../../Utilities/Session.svelte';

    let libraries = Library.getList();
    import {forms} from '../../lib/forms';

    function addLibrary() {
        addFormModal({
            fields: forms.library,
            title: "Add Library",
        }).then((data) => {
            Library.createItem(data).then(() => {
                notifier.success("Library Created")
            });;
        }).catch(e => {});
    }

    function deleteLibrary(library) {
        confirm(`Are you sure you want to delete ${library.name}?`).then(() => {
            let library_ = new Library(library._id);
            library_.delete().then(() => {
                notifier.success("Library Deleted")
            });;
        }).catch(() => {})
    }
</script>

<Loader loading={!$libraries}>
    <div class="container is-fluid">
        <h1 class="title is-1">Libraries</h1>
        <SortableTable sortFields={tables["libraries"]} tableData={$libraries} actionsWidth="{ $isAdmin ? 250 : 180 }">
            <div slot="filterActions">
                {#if $isAdmin}
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addLibrary}>Add Library</button>
                </div>
                {/if}
            </div>
            <div slot="footerActions">
                {#if $isAdmin }
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addLibrary}>Add Library</button>
                </div>
                {/if}
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={library}>
                {#if $isAdmin}
                <a class="button is-info" href="#/library/edit/{library._id}">Manage</a>
                {/if}
                <button class="button is-danger" on:click={() => deleteLibrary(library)}>Delete</button>
                <a class="button is-link" href="#/library/{library._id}">Open</a>
                {#await Library.getModerationItems(library._id)}
                    &nbsp;
                {:then items}
                    <a href="#/library/{library._id}/moderation" class="button" class:is-primary={items.rows.length}>Moderation Queue ({items.rows.length})</a>
                {/await}
            </div>
        </SortableTable>
    </div>
</Loader>